import vue from "../main";

export default function() {
  let sorted = [
    { id: 2001, name: vue.$t("$staticData.otherSummaryTypes.localTransport"), isVehicleTypeRequired: false },
    { id: 2002, name: vue.$t("$staticData.otherSummaryTypes.transportEntry"), isVehicleTypeRequired: true },
    { id: 2003, name: vue.$t("$staticData.otherSummaryTypes.parking"), isVehicleTypeRequired: true },
    { id: 2004, name: vue.$t("$staticData.otherSummaryTypes.fuel"), isVehicleTypeRequired: true },
    { id: 2005, name: vue.$t("$staticData.otherSummaryTypes.carRent"), isVehicleTypeRequired: false }
    // { id: 2006, name: vue.$t("$staticData.otherSummaryTypes.carRentFuel"), isVehicleTypeRequired: false },
  ].sort((a, b) => (a.name > b.name ? 1 : -1));
  sorted.push({ id: 2000, name: vue.$t("$staticData.otherSummaryTypes.other"), isVehicleTypeRequired: false });
  return sorted;
}

export function vehicleTypes() {
  return [
    { id: 1, name: vue.$t("$staticData.otherSummaryTypes.companyCar") },
    { id: 2, name: vue.$t("$staticData.otherSummaryTypes.rentedCar") },
    { id: 3, name: vue.$t("$staticData.otherSummaryTypes.employeeCar") }
  ].sort((a, b) => (a.name > b.name ? 1 : -1));
}
